export default __webpack_public_path__ + "static/media/Rockwool-sandwichpanel.45ce0b91.jpg";